import React, { useRef, useEffect, useContext } from "react"
import TransitionLink from "gatsby-plugin-transition-link"
import { CursorContext } from '../../../context/cursorContext'

const Overlay = ({ prev, next, pageContext }) => {
    const { cursorConfig, setCursor } = useContext(CursorContext);

    const transUp = useRef(null)
    const transDown = useRef(null)

    const triggerEscape = () => {
        if (
            pageContext.prev.replaceAll('/','') === 'designs' 
            && pageContext.next.replaceAll('/','') === 'designs'
        )  {
            transUp.current.click()
        }
    }

    const keydownHandler = (event) => {
        switch (event.keyCode) {
            case 27: //Escape
                triggerEscape()
                break
            case 32: // space
                transDown.current.click()
                break
            case 38: // arrow up
                transUp.current.click()
            case 40: 
                transDown.current.click()
            default: 
                break
        }    
    }

    useEffect(() => {
        if (!window)
            return
        window.addEventListener('keydown', keydownHandler)
        return () => {
            window.removeEventListener('keydown', keydownHandler)
        }
    }, [])

    useEffect(() => {
        const handleWheel = e => {
            if (e.deltaY > 0) {
                transDown.current.click()
            }
            if (e.deltaY < 0) {
                transUp.current.click()
            }
        }
        window.addEventListener("wheel", handleWheel)
        return () => window.removeEventListener("wheel", handleWheel)
    }, [])

    return (
        <>
            <div
                className="overlay-left"
                onMouseEnter={() => setCursor({
                    ...cursorConfig,
                    rotation: -90,
                    translation: '50%, -75%',
                    scale: "2",
                    color: 'var(--yellow)',
                    shape: "triangle"
                })}
                onClick={() => prev()}
                style={{
                    position: 'absolute',
                    height: '60%',
                    width: '50%',
                    top: '20%',
                }}
            />
            <div
                className="overlay-right"
                onMouseEnter={() => setCursor({
                    ...cursorConfig,
                    rotation: 90,
                    translation: '-150%, -25%',
                    scale: "2",
                    color: 'var(--yellow)',
                    shape: "triangle"
                })}
                onClick={() => next()}
                style={{
                    position: 'absolute',
                    height: '60%',
                    width: '50%',
                    top: '20%',
                    left: "50%",
                }}
            />
            {!pageContext.initial && <TransitionLink
                ref={transUp}
                className="design-trans"
                to={pageContext.prev}
                exit={{ length: 1, state: { direction: "up" } }}
                entry={{
                    length: 1,
                    state: { direction: "up" },
                    trigger: () => setCursor({ blocked: true })
                }}
                onMouseEnter={() => setCursor({
                    ...cursorConfig,
                    rotation: 0,
                    translation: '-25%, 50%',
                    scale: "2",
                    color: 'var(--yellow)',
                    shape: "triangle"
                })}
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '20%',
                    top: 0,
                    left: 0,
                }}
            >
            </TransitionLink>}
            <TransitionLink
                ref={transDown}
                className="design-trans"
                to={pageContext.next}
                exit={{ length: 1, state: { direction: "down" } }}
                entry={{
                    length: 1,
                    state: { direction: "down" },
                    trigger: () => setCursor({ blocked: true })
                }}
                onMouseEnter={() => setCursor({
                    ...cursorConfig,
                    rotation: cursorConfig.rotation === 90 ? 180 : -180,
                    translation: '-75%, -150%',
                    scale: "2",
                    color: 'var(--yellow)',
                    shape: "triangle"
                })}
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '20%',
                    bottom: 0,
                    left: 0,
                }}
            >
            </TransitionLink>
        </>
    )
}

export default Overlay

// export const query = graphql`

//   fragment SlideFormat on WpDesign {
//     format {
//       boundaries
//       shadow
//       size
//       ratio {
//         width
//         height
//       }
//     }
//   }

//   fragment SideDescription on WpDesign {
//     sideDescription {
//       lower
//       upper
//     }
//   }
// `;